/**
 * Ask-with-citations — chunk 9, `server/app/routers/ask.py`.
 *
 * A question spends a real model completion, so this is a mutation (like
 * `useStartPipelineRun`), never a `useQuery` a stray re-render could refire.
 * `citations` and `rejected` both come back from the server verbatim — this
 * module does not re-verify a quote's containment client-side, because the
 * server's `check_containment`-style verification is the one that decided
 * which half a citation landed in, and a client re-check would be a second,
 * lesser copy of that guard.
 */

import { useMutation } from '@tanstack/react-query'

import { api } from './client'
import type { AskRequest, AskResponse } from './types'

export function useAskCorpus() {
  return useMutation<AskResponse, unknown, AskRequest>({
    mutationFn: (body) => api.post<AskResponse>('/api/corpus/ask', body),
  })
}
